import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
	return (
		<a
			href="https://wa.me/916900259253"
			target="_blank"
			rel="noopener noreferrer"
			className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-accent flex items-center justify-center shadow-gold-lg hover:scale-110 transition-transform duration-200"
			aria-label="Chat on WhatsApp"
		>
			<MessageCircle className="w-7 h-7 text-accent-foreground" />
		</a>
	);
};

export default WhatsAppButton;
